
/**
 * @export
 * @enum {string}
 */
export enum AdvancedSearchType {
    COMPANY = 'COMPANY',
    INVESTOR = 'INVESTOR',
    DEBT = 'DEBT',
    SERVICE_PROVIDER = 'SERVICE_PROVIDER',
    LIMITED_PARTNER = 'LIMITED_PARTNER',
    PERSON = 'PERSON',
    FINANCIALS = 'FINANCIALS',
    MARKET_MAP = 'MARKET_MAP',
    SHARE_CLASS = 'SHARE_CLASS',
    FUND_BENCHMARK = 'FUND_BENCHMARK'
}